import * as Sentry from '@sentry/vue';

/**
 * Captures an error in Sentry with FATAL severity level.
 * Use this ONLY for errors that should be marked as fatal:
 * - Toast error messages shown to users
 * - Error page renders
 * 
 * DO NOT use for general error handling or routing.
 * 
 * @param {Error|string} error - The error object or error message
 * @param {Object} options - Sentry capture options
 * @param {Object} options.contexts - Additional context to send to Sentry
 * @param {Object} options.tags - Tags for Sentry
 * @returns {void}
 */
export function captureFatalError(error, { contexts = {}, tags = {} } = {}) {
    const sentryError = error instanceof Error ? error : new Error(String(error));
    
    // Log to console for development visibility
    console.error('[FATAL ERROR]', sentryError, { contexts, tags });
    
    Sentry.captureException(sentryError, {
        level: 'fatal',
        contexts,
        tags
    });
}

export default captureFatalError;
